/* ============================================================================
   FEATURED PRODUCTS PRO — COLLECTION PAGE JS (FINAL)
============================================================================ */

(function () {
  if (window.__FPP_COLL__) return;
  window.__FPP_COLL__ = true;

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  async function fppAddToCart(variantId) {
    const cartDrawer = document.querySelector("cart-drawer");
    const formData = new FormData();
    formData.append("id", variantId);
    formData.append("quantity", 1);
    
    let sections = [];
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === "function") {
       sections = cartDrawer.getSectionsToRender().map((s) => s.id);
    }
    if (sections.length === 0) sections = ["cart-drawer", "cart-icon-bubble"];
    
    formData.append("sections", sections.join(","));
    formData.append("sections_url", window.location.pathname);

    const fetchUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : window.Shopify.routes.root + 'cart/add.js';
    
    try {
        const response = await fetch(fetchUrl, { method: "POST", body: formData, headers: { "X-Requested-With": "XMLHttpRequest", "Accept": "application/javascript" }});
        const parsedState = await response.json();

        if (parsedState.status === 422 || parsedState.status === 404) {
             const errorMsg = parsedState.description || parsedState.message || "Item could not be added.";
             return alert(errorMsg);
        }

        const cartBubble = document.getElementById('cart-icon-bubble');
        if (cartBubble && parsedState.sections && parsedState.sections['cart-icon-bubble']) {
             const doc = new DOMParser().parseFromString(parsedState.sections['cart-icon-bubble'], 'text/html');
             const inner = doc.querySelector('#cart-icon-bubble');
             if (inner) cartBubble.innerHTML = inner.innerHTML;
        }

        if (cartDrawer) {
            cartDrawer.classList.remove('is-empty'); 
            const drawerInner = cartDrawer.querySelector('.drawer__inner');
            if (drawerInner) drawerInner.classList.remove('is-empty');

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') { 
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'featured-products-pro', cartData: parsedState, productVariantId: variantId }); 
            }

            if (typeof cartDrawer.renderContents === "function") {
                cartDrawer.renderContents(parsedState);
            } else if (parsedState.sections && parsedState.sections['cart-drawer']) {
                 const doc = new DOMParser().parseFromString(parsedState.sections['cart-drawer'], 'text/html');
                 const inner = doc.querySelector('#CartDrawer');
                 if (inner && document.querySelector('#CartDrawer')) document.querySelector('#CartDrawer').innerHTML = inner.innerHTML;
            }
            
            if (typeof cartDrawer.open === "function") cartDrawer.open();
            else cartDrawer.classList.add('active', 'animate');
        } else {
            window.location.href = window.Shopify.routes.root + 'cart';
        }
    } catch (err) {
        console.error(err);
        window.location.href = window.Shopify.routes.root + 'cart';
    }
  }

  async function fppBuyNow(variantId) {
    try {
      await fetch(window.Shopify.routes.root + "cart/clear.js", { method: "POST", headers: { "Content-Type": "application/json" } });
      const formData = new FormData();
      formData.append("id", variantId); formData.append("quantity", 1);
      
      const fetchUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : window.Shopify.routes.root + 'cart/add.js';
      const response = await fetch(fetchUrl, { method: "POST", body: formData });
      
      if (response.ok) {
          window.location.href = "/checkout";
      } else {
          const data = await response.json();
          alert(data.description || "Unable to buy now. Item may be out of stock.");
      }
    } catch (err) { 
        alert("Unable to start checkout. Please try again."); 
    }
  }

  /* --- DROPDOWN & FILTER LOGIC --- */
  function initFilters() {
    const grid = $("#fpp-product-grid");
    if (!grid) return;

    const minPriceInput = $("#fpp-filter-price-min"), maxPriceInput = $("#fpp-filter-price-max");
    const instockCheck = $("#fpp-filter-instock"), outstockCheck = $("#fpp-filter-outstock");
    const sizeCheckboxes = $$(".fpp-size-cb");
    const sortSelect = $("#fpp-sort-select");
    const countDisplay = $("#fpp-count-num");
    
    const emptyState = $("#fpp-empty-state");
    const emptyClearAllBtn = $("#fpp-clear-all-btn");
    const globalClearAllLink = $("#fpp-clear-all-active");

    const getCards = () => $$(".fpp-card", grid);

    document.addEventListener('click', (e) => {
      $$('details.fpp-filter-details').forEach(detail => {
        if (!detail.contains(e.target)) detail.removeAttribute('open');
      });
    });

    const applyFilters = () => {
      const minPrice = minPriceInput && minPriceInput.value ? parseFloat(minPriceInput.value) : 0;
      const maxPrice = maxPriceInput && maxPriceInput.value ? parseFloat(maxPriceInput.value) : Infinity;
      const showInStock = instockCheck ? instockCheck.checked : false;
      const showOutStock = outstockCheck ? outstockCheck.checked : false;
      const selectedSizes = sizeCheckboxes.filter(cb => cb.checked).map(cb => cb.value.toLowerCase());
      
      let visibleCount = 0;

      const isFilterActive = (
        (minPriceInput && minPriceInput.value) || 
        (maxPriceInput && maxPriceInput.value) || 
        showInStock || 
        showOutStock || 
        selectedSizes.length > 0
      );

      if (globalClearAllLink) {
        globalClearAllLink.style.display = isFilterActive ? "inline-block" : "none";
      }

      getCards().forEach(card => {
        const sizes = card.dataset.sizes || "";
        const priceRaw = parseFloat(card.dataset.priceRaw) || 0;
        const isAvailable = card.dataset.variantAvailable === "true";

        let match = true;

        if (priceRaw < minPrice || priceRaw > maxPrice) match = false;
        if (showInStock && !showOutStock && !isAvailable) match = false;
        if (showOutStock && !showInStock && isAvailable) match = false;

        if (selectedSizes.length > 0) {
          const cardHasSelectedSize = selectedSizes.some(s => sizes.includes(s + ","));
          if (!cardHasSelectedSize) match = false;
        }

        if (match) {
          card.style.display = "flex";
          visibleCount++;
        } else {
          card.style.display = "none";
        }
      });

      if (countDisplay) countDisplay.textContent = visibleCount;
      
      if (emptyState) {
        if (visibleCount === 0) {
          emptyState.style.display = "block";
        } else {
          emptyState.style.display = "none";
        }
      }
    };

    [minPriceInput, maxPriceInput].forEach(el => { if(el) el.addEventListener("input", applyFilters); });
    [instockCheck, outstockCheck, ...sizeCheckboxes].forEach(el => { if(el) el.addEventListener("change", applyFilters); });

    $$('.fpp-filter-details').forEach(detail => {
      const clearBtn = $('.fpp-btn-clear', detail);
      const applyBtn = $('.fpp-btn-apply', detail);

      if (clearBtn) {
        clearBtn.addEventListener('click', (e) => {
          e.preventDefault();
          $$('input[type="checkbox"]', detail).forEach(cb => cb.checked = false);
          $$('input[type="number"]', detail).forEach(num => num.value = '');
          applyFilters();
        });
      }

      if (applyBtn) {
        applyBtn.addEventListener('click', (e) => {
          e.preventDefault();
          detail.removeAttribute('open');
          applyFilters();
        });
      }
    });

    const clearAllFilters = (e) => {
      if(e) e.preventDefault();
      $$('.fpp-filter-details input[type="checkbox"]').forEach(cb => cb.checked = false);
      $$('.fpp-filter-details input[type="number"]').forEach(num => num.value = '');
      applyFilters();
    };

    if (emptyClearAllBtn) emptyClearAllBtn.addEventListener('click', clearAllFilters);
    if (globalClearAllLink) globalClearAllLink.addEventListener('click', clearAllFilters);

    applyFilters();

    if (sortSelect) {
      sortSelect.addEventListener("change", (e) => {
        const criteria = e.target.value, cards = getCards();
        const sortedCards = cards.sort((a, b) => {
          const priceA = parseFloat(a.dataset.priceRaw) || 0, priceB = parseFloat(b.dataset.priceRaw) || 0;
          const nameA = a.dataset.title.toLowerCase(), nameB = b.dataset.title.toLowerCase();
          switch (criteria) {
            case "price-low": return priceA - priceB;
            case "price-high": return priceB - priceA;
            case "name-az": return nameA.localeCompare(nameB);
            case "name-za": return nameB.localeCompare(nameA);
            default: return 0;
          }
        });
        sortedCards.forEach(card => grid.insertBefore(card, emptyState));
      });
    }
  }

  function initCard(card) {
    if (!card || card.__fpp_init) return;
    card.__fpp_init = true;

    const hasSizes = card.dataset.hasSizes === "true", defaultVariantId = card.dataset.defaultVariant;
    const addBtn = $(".fpp-add-btn", card), buyBtn = $(".fpp-buy-btn", card), sizeBtns = $$(".fpp-size-btn", card);
    const errorMsg = $(".fpp-error-msg", card), currentPriceEl = $(".fpp-current-price", card), oldPriceEl = $(".fpp-old-price", card);
    let selectedVariant = hasSizes ? null : defaultVariantId;

    sizeBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        if (btn.classList.contains("out-of-stock") || btn.disabled) return;
        sizeBtns.forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");
        selectedVariant = btn.dataset.variantId;

        if (currentPriceEl && btn.dataset.price) currentPriceEl.textContent = btn.dataset.price;
        if(btn.dataset.priceRaw) card.dataset.priceRaw = btn.dataset.priceRaw;

        if (oldPriceEl) {
          if (btn.dataset.comparePrice) { oldPriceEl.textContent = btn.dataset.comparePrice; oldPriceEl.style.display = "inline"; } 
          else oldPriceEl.style.display = "none";
        }
        if(errorMsg) errorMsg.style.display = 'none';
      });
    });

    if (addBtn) addBtn.addEventListener("click", () => {
      if (addBtn.disabled) return;
      if (hasSizes && !selectedVariant) return errorMsg.style.display = 'block';
      const btnText = addBtn.textContent;
      addBtn.textContent = "...";
      fppAddToCart(selectedVariant || defaultVariantId).finally(() => addBtn.textContent = btnText);
    });

    if (buyBtn) buyBtn.addEventListener("click", () => {
      if (hasSizes && !selectedVariant) return errorMsg.style.display = 'block';
      const btnText = buyBtn.textContent;
      buyBtn.textContent = "...";
      fppBuyNow(selectedVariant || defaultVariantId).finally(() => buyBtn.textContent = btnText);
    });
  }

  function initAll(root = document) { $$(".fpp-card", root).forEach(initCard); }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => { initFilters(); initAll(); });
  } else { initFilters(); initAll(); }

  new MutationObserver((mut) => {
    mut.forEach((m) => m.addedNodes.forEach((node) => { if (node.nodeType === 1) initAll(node); }));
  }).observe(document.body, { childList: true, subtree: true });
})();